import "./CreateMrfHr.css";
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContext";
import { Form, Input, Button, Typography, Card, Select, Space, Radio } from "antd";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function CreateMrfHr({ onSubmitSuccess }) {
    const { Link, Title } = Typography;
    const { Option } = Select;
    const [departments, setDepartments] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [workLocation, setWorkLocation] = useState([]);
    const { authData, backUrl } = useContext(AuthContext);
    const [showAddDesig, setShowAddDesig] = useState(false);
    const [showmessage, setShowmessage] = useState(false);
    const [allocatedTo, setAllocatedTo] = useState(0)
    const [loading, setLoading] = useState(false);

    const [hrTeam, setHrTeam] = useState([])

    const [errors, setErrors] = useState({});

    const message = "MRF submitted successfully!";

    const firstName = authData?.employee?.first_name || "Unknown";
    const designation = authData?.employee?.designation || "N/A";

    const r_to = authData.employee.reporting_to;

    const isMobile = window.innerWidth < 768;

    const data = `${designation}`;

    const [mrfdata, setMrfdata] = useState({
        organisation: '',
        department: null,
        site_location: '',
        required_by: '',
        designation: 1,
        no_of_vacancies: '',
        requisition_type: '',
        place_of_work: [],
        reporting_to: r_to,
        job_description: '',
        qualification: '',
        experience: '',
        skill_sets: '',
        other_requirements: '',
        justification: "",
        name_of_leaving_employee: '',
        reason_for_leaving: '',
        date_of_leaving: '',
        present_dept_strength: 3,
        strength_of_function: '',
        replacement_remarks: '',
        mrf_salary_from: '',
        mrf_salary_to: '',
        hr_approved: null,
        hr_approved_by: data,
        hr_remarks: '',
        status: 'Sanctioned',
        job_description_attachment: null
    });

    const validateForm = () => {
        const requiredFields = [
            'organisation', 'department', 'site_location', 'required_by', 'designation',
            'no_of_vacancies', 'requisition_type', 'place_of_work',
            'job_description', 'qualification', 'experience', 'skill_sets',
            'other_requirements', 'justification', 'mrf_salary_from', 'mrf_salary_to', 'hr_approved', 'hr_remarks'
        ];

        const newErrors = {};

        requiredFields.forEach(field => {
            if (!mrfdata[field]) {
                newErrors[field] = "This field is required.";
            }
        });

        if (mrfdata.requisition_type === 'Replacement') {
            ['name_of_leaving_employee', 'date_of_leaving', 'reason_for_leaving', 'present_dept_strength', 'strength_of_function', 'replacement_remarks'].forEach(field => {
                if (!mrfdata[field]) {
                    newErrors[field] = "This field is required.";
                }
            });
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const [addDesig, setAddDesig] = useState({
        name: '',
        department: "",
        grade: '',
        level: ''
    });


    const fetchHrTeam = async () => {
        const res = await axios.get(`${backUrl}/api/emp/employees/?department=25`, {
            headers: {
                Authorization: `Bearer ${authData?.access}`
            }
        })

        setHrTeam(res.data.results)

        console.log("HR Team : ", res.data.results)
    }

    const fetchDepartments = async (v) => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/departments/?organisation=${v}`);
            const departmentNames = res.data.results.map(dept => dept.name);
            setDepartments(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`);
            setOrganizations(res.data.results);
        } catch (err) {
            console.error("Failed to fetch organizations:", err);
        }
    };


    const fetchDesignations = async (departmentId) => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/designations/?department=${departmentId}`);
            setDesignations(res.data.results); // Store full objects
            console.log(designations)
        } catch (err) {
            console.error("Error fetching designations", err);
        }
    };

    const fetchWorkLocation = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/worklocation/`);
            setWorkLocation(res.data.results);
            console.log("workLocation", res.data.results)
        } catch (err) {
            console.error("Error fetching designations", err);
        }
    }


    useEffect(() => {
        fetchOrganizations();
        // fetchDepartments();
        fetchWorkLocation();
        fetchHrTeam();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        let parsedValue = value;

        if (name === "hr_approved") {
            parsedValue = value === "true"; // convert string to boolean
        } else if (type === "checkbox") {
            parsedValue = checked;
        }

        setMrfdata(prev => ({
            ...prev,
            [name]: parsedValue
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error("Please fill all required fields.");
            return;
        }

        if (!authData || !authData.access) {
            alert("Access token is missing! Please log in again.");
            return;
        }

        // Create FormData object to handle file upload
        const formData = new FormData();

        // Append all text fields
        Object.keys(mrfdata).forEach(key => {
            if (key === "place_of_work") {
                // Handle array
                mrfdata.place_of_work.forEach((loc, index) => {
                    formData.append(`place_of_work[${index}]`, loc);
                });
            } else if (key === "job_description_attachment") {
                // File will be appended below separately
            } else if (mrfdata[key] !== null && mrfdata[key] !== undefined && mrfdata[key] !== "") {
                formData.append(key, mrfdata[key]);
            }
        });

        // Append the file (if exists)
        if (mrfdata.job_description_attachment) {
            formData.append("job_description_attachment", mrfdata.job_description_attachment);
        }

        // Always append allocated HR
        formData.append("mrf_allocated_to", allocatedTo || "");

        // Format date if needed
        if (mrfdata.date_of_leaving) {
            const dateObj = new Date(mrfdata.date_of_leaving);
            const day = String(dateObj.getDate()).padStart(2, '0');
            const month = String(dateObj.getMonth() + 1).padStart(2, '0');
            const year = dateObj.getFullYear();
            formData.set("date_of_leaving", `${day}-${month}-${year}`);
        }

        try {
            setLoading(true);
            await axios.post(
                `${backUrl}/api/emp/manpowerrequisitions/`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${authData.access}`,
                        // Let browser set Content-Type with boundary
                        // 'Content-Type': 'multipart/form-data' → Do NOT set manually
                    }
                }
            );

            toast.success("MRF submitted successfully!");
            onSubmitSuccess();

            // Reset form
            setMrfdata({
                organisation: '',
                department: null,
                site_location: '',
                required_by: '',
                designation: 1,
                no_of_vacancies: '',
                requisition_type: '',
                place_of_work: [],
                reporting_to: data,
                job_description: '',
                qualification: '',
                experience: '',
                skill_sets: '',
                other_requirements: '',
                justification: "",
                name_of_leaving_employee: '',
                reason_for_leaving: '',
                date_of_leaving: '',
                present_dept_strength: '',
                strength_of_function: '',
                replacement_remarks: '',
                mrf_salary_from: "",
                mrf_salary_to: "",
                hr_approved: null,
                hr_approved_by: data,
                hr_remarks: '',
                status: 'Sanctioned',
                job_description_attachment: null
            });
            setAllocatedTo(0);

        } catch (error) {
            const errorMessage =
                error.response?.data?.data ||
                error.response?.data?.message ||
                "Failed to submit MRF";

            toast.error(errorMessage);
        }
        finally {
            setLoading(false)
        }
    };

    const handleAddDesig = () => {
        setShowAddDesig(true);
    };

    const addnewdesignation = async () => {
        try {
            await axios.post(`${backUrl}/api/emp/designations/`, addDesig);
            // setAddDesig({ name: '', department: '', grade: '', level: '' });
            setShowAddDesig(false);
            const deptId = mrfdata.department;
            if (deptId) {
                fetchDesignations(deptId);
            }
        } catch (err) {
            console.error("Failed to add designation:", err);
        }
    };

    const inputStyle = { width: '100%' }; // all inputs/selects full width



    return (
        <>
            {showAddDesig && (
                <div
                    style={{
                        position: "fixed",       // fixed positioning
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(3, 3, 3, 0.67)", // semi-transparent overlay
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,           // high z-index to be on top
                    }}
                >
                    <Card className="add-desig-form" bordered={false} style={{ maxWidth: 400, width: "90%" }}>
                        {/* Back link */}
                        <div style={{ marginBottom: "1rem" }}>
                            <a className="bread-anchor" id="bread-acr" onClick={() => setShowAddDesig(false)}>← Back</a>
                        </div>

                        {/* Form */}
                        <Form layout="vertical" onFinish={addnewdesignation}>
                            <Form.Item
                                label="Designation"
                                name="designation"
                                rules={[{ required: true, message: "Please enter designation name!" }]}
                            >
                                <Input
                                    placeholder="Designation Name"
                                    value={addDesig.name}
                                    style={inputStyle}
                                    onChange={(e) => setAddDesig({ ...addDesig, name: e.target.value })}
                                />
                            </Form.Item>

                            <Form.Item>
                                <Button style={{ backgroundColor: '#125ea7', color: 'white' }} htmlType="submit" block>
                                    Add Designation
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </div>
            )}


            {/* Continue the rest of your form code exactly as before */}
            {/* Your full JSX form content is intact from your original input and doesn't need correction */}
            <>
                {
                    isMobile ? (
                        <center><p style={{ textTransform: 'uppercase', color: '#0e497b' }}>Manpower Requisition Form(MRF)</p></center>

                    ) : (
                        < center > <h5>Manpower Requisition Form(MRF)</h5></center>
                    )

                }
                <div className="form container">
                    <div>
                        <Form.Item
                            label="Organization"
                            validateStatus={errors.organisation ? "error" : ""}
                            help={errors.organisation}
                        >
                            <Select
                                placeholder="-- Select --"
                                onChange={(value) => {
                                    handleChange({ target: { name: "organisation", value } });
                                    fetchDepartments(value);
                                }}
                                style={inputStyle}
                            >
                                <Option value="">-- Select --</Option>
                                {organizations.map((org) => (
                                    <Option key={org.id} value={org.id}>
                                        {org.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>
                    <Form.Item
                        label="Department"
                        validateStatus={errors.department ? "error" : ""}
                        help={errors.department}
                    >
                        <Select
                            showSearch
                            placeholder="-- Select --"
                            onChange={(value) => {
                                handleChange({ target: { name: "department", value } });
                                fetchDesignations(value);
                                setAddDesig({ ...addDesig, department: value });
                            }}
                            style={inputStyle}

                            filterOption={(input, option) =>
                                option?.children?.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            <Option value="">-- Select --</Option>

                            {departments.map((dept, idx) => (
                                <Option key={idx} value={dept.id}>
                                    {dept.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>


                    <div>
                        <Form.Item
                            label="Designation"
                            validateStatus={errors.designation ? "error" : ""}
                            help={errors.designation}
                        >
                            <Select
                                showSearch
                                placeholder="-- Select --"
                                value={
                                    isNaN(mrfdata.designation) ? mrfdata.designation : undefined
                                }
                                onChange={(value) => {
                                    if (value === "add-new") {
                                        handleAddDesig();
                                    } else {
                                        handleChange({ target: { name: "designation", value } });
                                    }
                                }}
                                filterOption={(input, option) =>
                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                }
                                style={inputStyle}
                            >
                                {designations.map((des, idx) => (
                                    <Option key={idx} value={des.id}>
                                        {des.name}
                                    </Option>
                                ))}
                                <Option value="add-new">➕ Add New Designation</Option>
                            </Select>
                        </Form.Item>
                    </div>


                    <div>
                        <Form.Item
                            label="Site/Location"
                            validateStatus={errors.site_location ? "error" : ""}
                            help={errors.site_location}
                        >
                            <Select
                                placeholder="-- Select --"
                                onChange={(value) =>
                                    handleChange({ target: { name: "site_location", value } })
                                }
                                style={inputStyle}
                            >
                                <Option value="">-- Select --</Option>
                                <Option value="Site Office">Site Office</Option>
                                <Option value="Head Office">Head Office</Option>
                            </Select>
                        </Form.Item>
                    </div>

                    <div>
                        <Form.Item
                            label="Required By"
                            validateStatus={errors.required_by ? "error" : ""}
                            help={errors.required_by}
                        >
                            <Input
                                placeholder="Specify in Months or Weeks"
                                value={mrfdata.required_by || ""}
                                onChange={(e) => handleChange(e)}
                                name="required_by"
                                style={inputStyle}
                            />
                        </Form.Item>
                    </div>

                    <div>
                        <Form.Item
                            label="No. of Vacancies"
                            validateStatus={errors.no_of_vacancies ? "error" : ""}
                            help={errors.no_of_vacancies}
                        >
                            <Input
                                placeholder="Number of Vacancies"
                                value={mrfdata.no_of_vacancies || ""}
                                onChange={(e) => handleChange(e)}
                                name="no_of_vacancies"
                                style={inputStyle}
                            />
                        </Form.Item>
                    </div>

                    {/* <div>
                        <label htmlFor="type">Requisition Type </label>
                        <select className="fixed-size" name="requisition_type" id="type" onChange={handleChange}>
                            <option value="">-- Select --</option>
                            <option value="New">New</option>
                            <option value="Replacement">Replacement</option>
                        </select>
                    </div> */}

                </div>
                <center>
                    <div id="requisition-type">
                        <Form.Item
                            label="Requisition Type"
                            validateStatus={errors.requisition_type ? "error" : ""}
                            help={errors.requisition_type}
                        >
                            <Select
                                placeholder="-- Select --"
                                value={mrfdata.requisition_type || undefined}
                                onChange={(value) =>
                                    handleChange({ target: { name: "requisition_type", value } })
                                }
                                style={inputStyle}
                            >
                                <Option value="">-- Select --</Option>
                                <Option value="New">New</Option>
                                <Option value="Replacement">Replacement</Option>
                            </Select>
                        </Form.Item>
                    </div>
                </center>



                <div className="form-2">
                    <div className="deployment-area">
                        <h5>Deployment</h5>
                        <Form layout="vertical">
                            <label htmlFor="place">Place Of Work</label>
                            <Select
                                mode="multiple"
                                placeholder="Select place(s) of work"
                                value={mrfdata.place_of_work}
                                onChange={(values) =>
                                    setMrfdata((prev) => ({
                                        ...prev,
                                        place_of_work: values,
                                    }))
                                }
                                style={{ width: "100%", marginBottom: `20px` }}
                            >
                                {workLocation.map((loc) => (
                                    <Option key={loc} value={loc.id}>
                                        {loc.name}
                                    </Option>
                                ))}
                            </Select>
                            {/* 
                        <label htmlFor="reportingto">Reporting To </label>
                        <p>{data}</p> */}

                            <Form.Item
                                label="Job Description"
                                validateStatus={errors.job_description ? "error" : ""}
                                help={errors.job_description}
                            >
                                <Input.TextArea
                                    placeholder="Job Description"
                                    value={mrfdata.job_description || ""}
                                    name="job_description"
                                    onChange={handleChange}
                                    rows={4} // optional: adjust height
                                    style={inputStyle}
                                />
                            </Form.Item>

                            <label htmlFor="jd">Job Description Upload</label>
                            <input
                                type="file"
                                name="job_description_attachment"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    setMrfdata(prev => ({
                                        ...prev,
                                        job_description_attachment: file || null
                                    }));
                                }}
                                accept=".pdf,.doc,.docx"
                            />
                        </Form>



                        <hr />

                        {/* salary range */}
                        {/* salary range */}
                        <h5>Salary Range</h5>

                        <Form.Item
                            label="From"
                            validateStatus={errors.mrf_salary_from ? "error" : ""}
                            help={errors.mrf_salary_from}
                        >
                            <Input
                                placeholder="from"
                                value={mrfdata.mrf_salary_from}
                                name="mrf_salary_from"
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (/^\d*$/.test(val)) {
                                        setMrfdata(prev => ({ ...prev, mrf_salary_from: val }));
                                    }
                                }}
                                style={inputStyle}
                            />
                        </Form.Item>

                        <Form.Item
                            label="To"
                            validateStatus={errors.mrf_salary_to ? "error" : ""}
                            help={errors.mrf_salary_to}
                        >
                            <Input
                                placeholder="to"
                                value={mrfdata.mrf_salary_to}
                                name="mrf_salary_to"
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (/^\d*$/.test(val)) {
                                        setMrfdata(prev => ({ ...prev, mrf_salary_to: val }));
                                    }
                                }}
                                style={inputStyle}
                            />
                        </Form.Item>

                    </div>

                    <div className="requirement-profile">
                        <h5>Requirement Profile</h5>
                        <Form layout="vertical">
                            {/* Qualification */}
                            <Form.Item
                                label="Qualification"
                                validateStatus={errors.qualification ? "error" : ""}
                                help={errors.qualification}
                            >
                                <Input
                                    placeholder="Qualification"
                                    value={mrfdata.qualification || ""}
                                    name="qualification"
                                    onChange={handleChange}
                                    style={inputStyle}
                                />
                            </Form.Item>
                            {/* Experience */}
                            <Form.Item
                                label="Experience"
                                validateStatus={errors.experience ? "error" : ""}
                                help={errors.experience}
                            >
                                <Input
                                    placeholder="Experience - eg if 1 year 10 months, 1/10"
                                    value={mrfdata.experience || ""}
                                    name="experience"
                                    onChange={handleChange}
                                    style={inputStyle}
                                />
                            </Form.Item>
                            {/* Skill Sets */}
                            <Form.Item
                                label="Skill Sets"
                                validateStatus={errors.skill_sets ? "error" : ""}
                                help={errors.skill_sets}
                            >
                                <Input.TextArea
                                    placeholder="Skill Sets"
                                    value={mrfdata.skill_sets || ""}
                                    name="skill_sets"
                                    onChange={handleChange}
                                    rows={4}
                                    style={inputStyle}
                                />
                            </Form.Item>
                            {/* Any Other Requirements */}
                            <Form.Item
                                label="Any Other Requirements"
                                validateStatus={errors.other_requirements ? "error" : ""}
                                help={errors.other_requirements}
                            >
                                <Input.TextArea
                                    placeholder="Any other Requirements"
                                    value={mrfdata.other_requirements || ""}
                                    name="other_requirements"
                                    onChange={handleChange}
                                    rows={4}
                                    style={inputStyle}
                                />
                            </Form.Item>
                            {/* Justification */}
                            <Form.Item
                                label="Justification"
                                validateStatus={errors.justification ? "error" : ""}
                                help={errors.justification}
                            >
                                <Input.TextArea
                                    placeholder="Justification"
                                    value={mrfdata.justification || ""}
                                    name="justification"
                                    onChange={handleChange}
                                    rows={4}
                                    style={inputStyle}
                                />
                            </Form.Item>
                        </Form>

                    </div>
                </div>




                {
                    mrfdata.requisition_type === 'Replacement' && (
                        <>
                            <h5>If Replacement</h5>
                            <div className="replacement-form">
                                <div className="form-group">
                                    <label htmlFor="leavingemployee">Name of the Leaving Employee </label>
                                    <input type="text" id="leavingemployee" name="name_of_leaving_employee" value={mrfdata.name_of_leaving_employee || ""} onChange={handleChange} placeholder="Name of the leaving employee" />
                                    {errors.name_of_leaving_employee && <p style={{ color: 'red', fontSize: '12px' }}>{errors.name_of_leaving_employee}</p>}

                                    <label htmlFor="leavingdate">Date of Leaving </label>
                                    <input
                                        type="date"
                                        id="leavingdate"
                                        name="date_of_leaving"
                                        value={mrfdata.date_of_leaving || ""}
                                        onChange={handleChange}
                                    />
                                    {errors.date_of_leaving && <p style={{ color: 'red', fontSize: '12px' }}>{errors.date_of_leaving}</p>}

                                    <label htmlFor="reason">Reason for Leaving </label>
                                    <textarea id="reason" name="reason_for_leaving" placeholder="Reason for Leaving" value={mrfdata.reason_for_leaving || ""} onChange={handleChange}></textarea>
                                    {errors.reason_for_leaving && <p style={{ color: 'red', fontSize: '12px' }}>{errors.reason_for_leaving}</p>}
                                </div>

                                <div className="form-group">
                                    <label htmlFor="strength">Present Strength in the Category </label>
                                    <input type="text" id="strength" name="present_dept_strength" placeholder="Present Strength in the Category" onChange={handleChange} value={mrfdata.present_dept_strength || ""} />
                                    {errors.present_dept_strength && <p style={{ color: 'red', fontSize: '12px' }}>{errors.present_dept_strength}</p>}

                                    <label htmlFor="strengthfunction">Strength of the Function </label>
                                    <input type="text" id="strengthfunction" name="strength_of_function" placeholder="Strength of the Function" onChange={handleChange} value={mrfdata.strength_of_function || ""} />
                                    {errors.strength_of_function && <p style={{ color: 'red', fontSize: '12px' }}>{errors.strength_of_function}</p>}

                                    <label htmlFor="remarks">Remarks </label>
                                    <textarea id="remarks" name="replacement_remarks" placeholder="Remarks" value={mrfdata.replacement_remarks || ""} onChange={handleChange}></textarea>
                                    {errors.replacement_remarks && <p style={{ color: 'red', fontSize: '12px' }}>{errors.replacement_remarks}</p>}
                                </div>
                            </div>
                        </>
                    )
                }

                <div className="p-5" id="approval-area-hr">
                    <center><h5>APPROVAL</h5></center>
                    <div className="approval-area">
                        <div className="d-flex">
                            <label>
                                <input
                                    type="radio"
                                    name="hr_approved"
                                    value="true"
                                    checked={mrfdata.hr_approved === true}
                                    onChange={handleChange}
                                /> Approve
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="hr_approved"
                                    value="false"
                                    checked={mrfdata.hr_approved === false}
                                    onChange={handleChange}
                                /> Reject
                            </label>

                        </div>
                        {errors.hr_approved && <p style={{ color: 'red', fontSize: '12px' }}>{errors.hr_approved}</p>}

                        <textarea
                            name="hr_remarks"
                            value={mrfdata.hr_remarks}
                            onChange={handleChange}
                            placeholder="Remarks"
                            style={{ width: isMobile ? "300px" : "500px" }}
                        />
                        {errors.hr_remarks && <p style={{ color: 'red', fontSize: '12px' }}>{errors.hr_remarks}</p>}
                    </div>

                    <br />

                    <center>
                        <Select
                            placeholder="Select HR"
                            style={{ width: 200 }}
                            allowClear
                            name="allocatedTo"
                            onChange={(value) => setAllocatedTo(value)}
                        >
                            {hrTeam.map((item) => (
                                <Option key={item.id} value={item.id}>
                                    {item?.first_name}
                                </Option>
                            ))}
                        </Select>
                    </center>



                    <center><Button style={{ backgroundColor: '#125ea7', color: 'white' }}
                        onClick={handleSubmit}
                        loading={loading}
                        disabled={loading}>
                        Submit MRF
                    </Button></center>
                </div>

                {showmessage && <p className="success-message">{message}</p>}
            </>
        </>
    );
}
